export type TimeRange = 'all' | '24h' | '7d' | '30d';
export type SortOrder = 'time' | 'alpha';

export const timeOptions: { value: TimeRange; label: string }[] = [
  { value: 'all', label: '不限时间' },
  { value: '24h', label: '最近24小时' },
  { value: '7d', label: '最近7天' },
  { value: '30d', label: '最近30天' },
];

export const sortOptions: { value: SortOrder; label: string }[] = [
  { value: 'time', label: '发布时间倒序' },
  { value: 'alpha', label: '标题字母顺序' },
];

interface FilterPanelProps {
  timeRange: TimeRange;
  sortOrder: SortOrder;
  onTimeChange: (v: TimeRange) => void;
  onSortChange: (v: SortOrder) => void;
  onReset: () => void;
  resultCount: number;
}

export default function FilterPanel({
  timeRange,
  sortOrder,
  onTimeChange,
  onSortChange,
  onReset,
  resultCount,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-bold font-heading text-foreground-950">筛选</h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置筛选
        </button>
      </div>

      <div className="mt-5">
        <p className="text-xs font-medium text-foreground-400 uppercase tracking-wide">按时间</p>
        <div className="mt-3 flex flex-col gap-1">
          {timeOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onTimeChange(opt.value)}
              className={`flex items-center justify-between px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                timeRange === opt.value
                  ? 'bg-primary-50 text-primary-600 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {opt.label}
              {timeRange === opt.value && <i className="ri-check-line"></i>}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <p className="text-xs font-medium text-foreground-400 uppercase tracking-wide">按顺序</p>
        <div className="mt-3 flex flex-col gap-1">
          {sortOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onSortChange(opt.value)}
              className={`flex items-center justify-between px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                sortOrder === opt.value
                  ? 'bg-primary-50 text-primary-600 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {opt.label}
              {sortOrder === opt.value && <i className="ri-check-line"></i>}
            </button>
          ))}
        </div>
      </div>

      <p className="mt-6 pt-4 border-t border-background-200 text-xs text-foreground-500">
        当前共 <span className="font-semibold text-foreground-900">{resultCount}</span> 条资讯
      </p>
    </div>
  );
}